import { useEffect, useRef } from 'react'
import { useLocation, useNavigationType } from 'react-router-dom'

function ScrollToTop() {
  const location = useLocation()
  const navigationType = useNavigationType()
  const previousPathRef = useRef(location.pathname)

  useEffect(() => {
    const previousPath = previousPathRef.current
    previousPathRef.current = location.pathname

    if (navigationType === 'POP') return
    if (location.hash) return
    if (previousPath === location.pathname && location.search) return

    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }, [location.hash, location.pathname, location.search, navigationType])

  return null
}

export default ScrollToTop
